import { RULES_CHECKPOINT } from '../content/tutorial';
import type { GameVariant } from '../../shared/config';
import type { GameMode } from '../../shared/modes';
import type { Screen } from './navigation';

export interface LobbyRulesInput {
  screen: Screen;
  mode: GameMode;
  /** The host is taught at Start instead. */
  host: boolean;
  readyCheckOpen: boolean;
  /** The results reveal has finished, so the recap is a place to wait between rounds. */
  resultsSettled: boolean;
  /** The room's variant for its next round. */
  variant: GameVariant;
}

/**
 * The variant to offer a guest who waits between rounds of a room-checkpoint mode, or null.
 * The join gate teaches the room's variant at join, but the host can change it afterwards and
 * start without the guest taking another action. A ready check closes the offer: its timed
 * window is too short for the pages.
 */
export function lobbyRulesDue(input: LobbyRulesInput): GameVariant | null {
  if (input.host || input.readyCheckOpen || RULES_CHECKPOINT[input.mode] !== 'room') return null;
  const waiting = input.screen === 'lobby' || (input.screen === 'results' && input.resultsSettled);
  return waiting ? input.variant : null;
}
